import { gql } from '@apollo/client';

export const UPDATE_SOIL_MONITOR = gql`
    mutation UpdateSoilMonitor($id: Guid!, $input: UpdateSoilMonitor!) {
        facility {
            process {
                updateSoilMonitor(id: $id, input: $input) {
                    id
                }
            }
        }
    }
`;
